import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CatalogoMarcaService } from '@services/catalogo/catalogoMarca.service';
import { FormularioMarcaComponent } from './formulario-marca/formulario-marca.component';
import { MarcaModel } from '@/store/catalogos/marcas';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-marca',
  templateUrl: './marca.component.html',
  styleUrls: ['./marca.component.scss']
})
export class MarcaComponent {
PROP = properties;
  displayedColumns: string[] = ['marca', 'options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private marcaService: CatalogoMarcaService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this. loadMarca();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadMarca() {
    this.marcaService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioMarcaComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:null}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadMarca();
      }
    });
  }

  update(row: MarcaModel) {
    const dialogRef = this.dialog.open(FormularioMarcaComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:true,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadMarca();
      }
    });
  }

  view(row: MarcaModel) {
    const dialogRef = this.dialog.open(FormularioMarcaComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:false,view:true,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadMarca();
      }
    });
  }
}
